<template>
  <div>
      <div class="post">
            <span id="contentLoaded"></span>
        <span class="rightPanel">
          <DateBadge :date="article.date"/>
        </span>
        <span class="leftPanel">
          <h3>
            {{article.title}}
          </h3>
          <span class="tags">
            <span v-for="tag in article.tags" class="post-tag">
              {{tag}}
            </span>
          </span>
        </span>
        <p class="contentShort">
          {{article.contentShort}}
        </p>
        <div style="clear: both"></div>
      </div>
      <div>
        <p>
        <transition name="fade">
          <p v-if="loaded" class="contentFull">
            <vue-markdown :source="article.content" />
          </p>
        </transition>
        </p>
      </div>
      <vue-disqus shortname="gwenaelp-blog"></vue-disqus>
  </div>
</template>

<script>
import Router from 'vue-router';

import store from '@/store';
import Vue from 'vue';

import DateBadge from '@/components/DateBadge';
import VueMarkdown from 'vue-markdown';

import VueDisqus from 'vue-disqus/VueDisqus.vue';

import prism from 'prismjs';
require('prismjs/themes/prism.css');

const posts = store.state.posts;

export default {
  name: 'BlogPost',

  data() {
    var article;
    for (var i = 0; i < posts.length; i++) {
      if(posts[i].id.toString() === this.$route.params.id) {
        article = posts[i];
      }
    }

    var _this = this;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/blog/static/articles/' + this.$route.params.id + '.md');

    xhr.onload = () => {
        const newArticle = Object.assign({}, this.article);
        if (xhr.status === 200) {
          newArticle.content = xhr.responseText;
          _this.$set(_this, 'article', newArticle);
          _this.loaded = true;
        }
        else {
          newArticle.content = xhr.status + ' error. Sorry, the content is unavailable right now';
          _this.$set(_this, 'article', newArticle);
        }
        setTimeout(function () {
          document.dispatchEvent(new Event('vue-content-render'));
        }, 1);

    };
    xhr.send();

    article.content = 'initial value';
    return {
      loaded: false,
      pageUrl: 'https://gwenaelp.github.io/blog/#/article/' + this.$route.params.id,
      article,
    };
  },

  updated: function () {
    this.$nextTick(function () {
      let codeBlocks = document.querySelectorAll('pre code');
      for (var i = 0; i < codeBlocks.length; i++) {

        codeBlocks[i].classList.add(codeBlocks[i].classList[0].split('-'));
        hljs.highlightBlock(codeBlocks[i]);
      }
    })
  },

  components: {
    DateBadge,
    VueMarkdown,
    VueDisqus,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/BlogPost.vue